import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  constructor() {}
  public arrayPath: string[] = [];

  ngOnInit(): void {}

  public getUrl() {
    let language = '';
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
      language = '/jp';
    } else {
      language = '';
    }
    return language;
  }

  public getLawsLink() {
    let language = '';
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
      language = 'https://www.japaneselawtranslation.go.jp/ja/laws/view/3213';
    } else {
      language = 'https://www.japaneselawtranslation.go.jp/en/laws/view/3213';
    }
    return language;
  }
}
